<div class="section-disparo" [class.section-disparo--com-integracao]="realizarIntegracao">
  <div class="painel-lista painel-contatos">
    <div class="abas-origem">
      <button type="button"
              class="aba aba-base"
              [class.aba-ativa]="origem === 'BASE_DINAMICA'"
              [disabled]="!podeEditar"
              (click)="selecionarAba('BASE_DINAMICA')">
        <span class="aba-icone"></span>
        <span class="aba-label">Bases Dinâmicas</span>
      </button>
      <button type="button"
              class="aba aba-excel"
              [class.aba-ativa]="origem === 'EXCEL'"
              [disabled]="!podeEditar"
              (click)="selecionarAba('EXCEL')">
        <span class="aba-icone"></span>
        <span class="aba-label">Arquivo Excel</span>
      </button>
    </div>

    <div class="corpo-lista">
      <div class="cabecalho-base-integracao">
        <span class="label-campo">
          {{ origem === 'EXCEL' ? 'Anexar base de contatos' : 'Selecionar base de contatos' }}
        </span>
        <app-slide-toggle-padrao
          labelTrue="Realizar integração"
          labelFalse=""
          fontSize="12px"
          [invertido]="true"
          [disabled]="!podeEditar"
          [valor]="realizarIntegracao"
          (changeValue)="alterarRealizarIntegracao($event)">
        </app-slide-toggle-padrao>
      </div>

      @if (carregandoInicial) {
        <div class="area-contatos">
          <app-tabela-skeleton class="width-100" [qntdLinhas]="8"></app-tabela-skeleton>
        </div>
      } @else if (origem === 'EXCEL') {
        <div class="bloco-anexo">
          <app-anexo-lista-envio
            [anexoArquivo]="anexo"
            [podeEditar]="podeEditar"
            [tipoDisparo]="disparoAutomatico.tipoDisparo"
            (envioAnexo)="receberAnexo($event)"
            (colunasComplementaresAtualizadas)="receberColunasComplementares($event)">
          </app-anexo-lista-envio>
        </div>
        <div class="area-contatos">
          <app-lista-contatos
            class="width-100"
            [anexo]="anexo"
            [disparoId]="disparoIdParaCarregarContatos"
            [statusDisparo]="statusDisparo"
            [tipoDisparo]="disparoAutomatico.tipoDisparo"
            [temIntegracao]="realizarIntegracao"
            [templateSms]="disparoAutomatico.template"
            [variaveis]="variaveis"
            [exibirReenvioIntegracao]="exibirReenvioIntegracao"
            [reenviandoIntegracao]="reenviandoIntegracao"
            (reenviarIntegracao)="reenviarIntegracao.emit()"
            (contatosCarregados)="contatosPreviewAtualizados.emit($event)">
          </app-lista-contatos>
        </div>
      } @else if (disparoAutomatico.id) {
        <div class="area-contatos">
          <app-lista-contatos
            class="width-100"
            [disparoId]="disparoAutomatico.id"
            [statusDisparo]="statusDisparo"
            [tipoDisparo]="disparoAutomatico.tipoDisparo"
            [temIntegracao]="realizarIntegracao"
            [templateSms]="disparoAutomatico.template"
            [variaveis]="variaveis"
            [exibirReenvioIntegracao]="exibirReenvioIntegracao"
            [reenviandoIntegracao]="reenviandoIntegracao"
            (reenviarIntegracao)="reenviarIntegracao.emit()"
            (contatosCarregados)="contatosPreviewAtualizados.emit($event)">
          </app-lista-contatos>
        </div>
      } @else {
        <div class="area-contatos">
          <app-contatos-base-dados
            class="width-100"
            [setorId]="setorId"
            [podeEditar]="podeEditar"
            [disparoAutomatico]="disparoAutomatico"
            [variaveis]="variaveis"
            [exibirReenvioIntegracao]="exibirReenvioIntegracao"
            [reenviandoIntegracao]="reenviandoIntegracao"
            (reenviarIntegracao)="reenviarIntegracao.emit()"
            (colunasComplementaresAtualizadas)="receberColunasComplementares($event)"
            (contatosPreviewAtualizados)="contatosPreviewAtualizados.emit($event)">
          </app-contatos-base-dados>
        </div>
      }

    </div>
  </div>

  @if (realizarIntegracao) {
    <div class="painel-lista painel-integracao">
      <app-integracao-disparo
        [disparoAutomatico]="disparoAutomatico"
        [podeEditar]="podeEditar">
      </app-integracao-disparo>
    </div>
  }
</div>
